import type { FlowMedium, PhysicsSourceType } from '@/types/scene'

export function flowMediumLabel(m: FlowMedium): string {
  const map: Record<FlowMedium, string> = {
    water: '水',
    air: '空气',
    steam: '蒸汽',
  }
  return map[m] ?? String(m)
}

export function physicsSourceTypeLabel(t: PhysicsSourceType): string {
  const map: Record<PhysicsSourceType, string> = {
    heat: '热源',
    humidity: '加湿',
    fan: '风机',
    valve: '阀门',
  }
  return map[t] ?? String(t)
}

/** 绑定/详情里 targetType 存的是英文枚举 */
export function physicsTargetKindLabel(kind: string): string {
  if (kind === 'zone') return '区域'
  if (kind === 'edge') return '管段'
  if (kind === 'source') return '源项'
  return kind
}
